import {
  Transforms,
  Path
} from 'slate';
import { nanoid } from 'nanoid';
import * as basicEditorValueSerializer from 'basic-editor-value-serializer';

import serverInterface from 'server-interface';

import types from '../../elements/types';

import HelptapEditor from '../';

export function getDefaultOptions() {

  return basicEditorValueSerializer.utilities.node.paragraph.getDefaultOptions();

}

export function buildNode(options = {}) {

  const node = {
    ...getDefaultOptions(),
    type: types.CANVAS,
    children: [{ text: '' }],
    height: '300px',
    resizable: true
  };
  const parentEntityType = options.parentEntityType;
  const parentEntityId = options.parentEntityId;
  const version = nanoid();
  const url = serverInterface.startup.getFullURL(`/canvases/${parentEntityType}:${parentEntityId}:${version}/image`).toString();

  node.properties = {
    ...node.properties,
    parentEntityType,
    parentEntityId,
    url,
    width: '100%',
    height: '100%',
    backgroundColor: null,
    gridEnabled: false,
    snapToGrid: true,
    gridSize: 20,
    data: {
      version: '6.4.3',
      objects: [{
        fontSize: 24,
        fontWeight: 'normal',
        fontFamily: 'Arial',
        fontStyle: 'normal',
        lineHeight: 1.16,
        text: 'Hello World',
        charSpacing: 0,
        textAlign: 'left',
        styles: [],
        path: null,
        pathStartOffset: 0,
        pathSide: 'left',
        pathAlign: 'baseline',
        underline: false,
        overline: false,
        linethrough: false,
        textBackgroundColor: '',
        direction: 'ltr',
        minWidth: 20,
        splitByGrapheme: false,
        type: 'Textbox',
        version: '6.4.3',
        originX: 'center',
        originY: 'center',
        left: 150,
        top: 250,
        width: 62.24,
        height: 58.5792,
        fill: '#f60039',
        stroke: null,
        strokeWidth: 1,
        strokeDashArray: null,
        strokeLineCap: 'butt',
        strokeDashOffset: 0,
        strokeLineJoin: 'miter',
        strokeUniform: false,
        strokeMiterLimit: 4,
        scaleX: 1,
        scaleY: 1,
        angle: 0,
        flipX: false,
        flipY: false,
        opacity: 1,
        shadow: null,
        visible: true,
        backgroundColor: '',
        fillRule: 'nonzero',
        paintFirst: 'fill',
        globalCompositeOperation: 'source-over',
        skewX: 0,
        skewY: 0
      }]
    }
  };

  return node;

}

export function insert(editor, options, editorOptions, targetNodePath, nextNodePath) {

  Transforms.insertNodes(editor, buildNode(options), { at: targetNodePath });
  Transforms.select(editor, [...targetNodePath]);
  HelptapEditor.paragraph.insert(editor, Path.next(targetNodePath));
}

export function toggle(editor, options, editorOptions, targetNodePath, nextNodePath) {

  const nodeOptions = buildNode(options);

  HelptapEditor.setNodeOptions(editor, nodeOptions);
  HelptapEditor.paragraph.insert(editor, nextNodePath);
  Transforms.select(editor, [...targetNodePath]);

}

export function duplicate(editor, node, nodePath) {

  const clonedNode = HelptapEditor.cloneNode(node);

  clonedNode.properties.parentEntityId = editor.parentEntityId;
  clonedNode.properties.parentEntityType = editor.parentEntityType;

  HelptapEditor.insertNode(editor, clonedNode, nodePath);

}

export function isCanvasNode(node) {

  return node.type === types.CANVAS;

}